import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import type { SortableTreeDropIndicatorMeta } from './SortableTreeItem';
import type { SortableTreeBaseContainer, SortableTreeBaseItem } from './types';

/**
 * The default {@link SortableTree} drop indicator: a line marking where the
 * active node will land. SortableTree indents it to the projected depth.
 * Arrows show which way a horizontal drag reaches another valid depth.
 */
const SortableTreeDropIndicator = <
  TItem extends SortableTreeBaseItem,
  TContainer extends SortableTreeBaseContainer = SortableTreeBaseContainer,
>(
  props: SortableTreeDropIndicatorMeta<TItem, TContainer>
) => {
  const { isInvalidDrop, canOutdent, canIndent } = props;

  return (
    <div className="py-1 pl-1.5">
      <div
        className={clstx(
          'relative h-0.5 rounded-full',
          isInvalidDrop ? 'bg-red-500' : 'bg-blue-500'
        )}
      >
        {canOutdent && (
          <UntitledIcon
            name="chevron-left"
            className="absolute top-1/2 -left-6 size-4 -translate-y-1/2 text-blue-500"
            aria-hidden
          />
        )}
        <span
          className={clstx(
            'absolute top-1/2 -left-1.5 size-2.5 -translate-y-1/2 rounded-full border-2 bg-white',
            isInvalidDrop ? 'border-red-500' : 'border-blue-500'
          )}
        />
        {canIndent && (
          <UntitledIcon
            name="chevron-right"
            className="absolute top-1/2 left-1.5 size-4 -translate-y-1/2 rounded-full bg-white text-blue-500"
            aria-hidden
          />
        )}
      </div>
    </div>
  );
};

export default SortableTreeDropIndicator;
